// extracted by mini-css-extract-plugin
export default {"root":"KuyxYBCcpx","content":"Qfg7ypFiul"};